import { render, staticRenderFns } from "./OrderExpirationExtender.vue?vue&type=template&id=327fda0f"
import script from "./OrderExpirationExtender.vue?vue&type=script&lang=js"
export * from "./OrderExpirationExtender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports